<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('blood-providers::page.title.laboratories_cc') }}</h2>
            <laboratory-c-c-data-table :list-route="listRoute"></laboratory-c-c-data-table>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
};
</script>
